import Layout from '@/layout';
var jdStoreRouter = {
  path: '/jdStore',
  component: Layout,
  redirect: '/jdStore/jdSkuList',
  name: 'JdStore',
  meta: {
    title: '京东管理',
    icon: 'shopping'
  },
  children: [{
    path: 'jdSkuList',
    name: 'JdSkuList',
    component: function component() {
      return import('@/views/jdStore/jdSkuList/index.vue');
    },
    meta: {
      title: '京东SKU列表',
      icon: ''
    }
  }, {
    path: 'jdSrot',
    name: 'JdSrot',
    component: function component() {
      return import('@/views/jdStore/jdSrot/index.vue');
    },
    meta: {
      title: '京东分类',
      icon: ''
    }
  }]
};
export default jdStoreRouter;